import { applicationState } from '@/states/applicationState';
import { Button } from '@arkas/coreui';
import { connect } from 'react-redux';
import kullaniciModel from '@/states/kullaniciModel';
import lodash from 'lodash';
import React from 'react';
import { UserDto } from '@emutabakat-types/anaveri';

interface LanguageSelectProps {
  currentUser: UserDto;
}

interface LanguageSelectStates {}

/**
 * LanguageSelect Component
 */
class LanguageSelect extends React.Component<
  LanguageSelectProps,
  LanguageSelectStates
> {
  constructor(props: LanguageSelectProps) {
    super(props);
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
    this.state = { hidden: true };
  }

  componentDidMount() {}

  handleChangeLanguage = () => {
    const { currentUser } = this.props;
    kullaniciModel
      .switchPreferredLanguage(currentUser.id.toString())
      .then(response => {
        kullaniciModel.setCurrentUser(response.currentUser);
        window.location.reload();
      });
  };

  render() {
    const { currentUser } = this.props;
    if (lodash.isEmpty(currentUser) || currentUser.isArkasUser) return null;
    return (
      <div>
        <Button
          ghost={true}
          className="sider-toggle-button"
          onClick={this.handleChangeLanguage}
          style={{ color: 'white' }}
          title={currentUser.tercihEdilenDil.toUpperCase()}
          size="small"
        >
          {currentUser.tercihEdilenDil.toUpperCase()}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state: applicationState) => ({
  currentUser: state.kullaniciModel.currentUser
});

export default connect(mapStateToProps)(LanguageSelect);
